import { getModule10FromCodePart, isModule10, validateModule10 } from '../validateModule10';
import { getModule11FromCodePart, validateModule11 } from '../validateModule11';

export const getAgreementDigitableLineFromBarCode = (barCode: string) => {
  const firstCodePart = barCode.substring(0, 11);
  const secondCodePart = barCode.substring(11, 22);
  const thirdCodePart = barCode.substring(22, 33);
  const fourthCodePart = barCode.substring(33, 44);

  let firstVerifierDigit = '';
  let secondVerifierDigit = '';
  let thirdVerifierDigit = '';
  let fourthVerifierDigit = '';

  if (isModule10(barCode)) {
    firstVerifierDigit = getModule10FromCodePart(firstCodePart);
    secondVerifierDigit = getModule10FromCodePart(secondCodePart);
    thirdVerifierDigit = getModule10FromCodePart(thirdCodePart);
    fourthVerifierDigit = getModule10FromCodePart(fourthCodePart);
  } else {
    firstVerifierDigit = getModule11FromCodePart(firstCodePart);
    secondVerifierDigit = getModule11FromCodePart(secondCodePart);
    thirdVerifierDigit = getModule11FromCodePart(thirdCodePart);
    fourthVerifierDigit = getModule11FromCodePart(fourthCodePart);
  }

  const digitableLine1stPart = `${firstCodePart}${firstVerifierDigit}${secondCodePart}`;
  const digitableLine2ndPart = `${secondVerifierDigit}${thirdCodePart}`;
  const digitableLine3rdPart = `${thirdVerifierDigit}${fourthCodePart}${fourthVerifierDigit}`;
  const digitableLine = `${digitableLine1stPart}${digitableLine2ndPart}${digitableLine3rdPart}`;

  return digitableLine;
};

export const validateAgreementDigitableLine = (barCode: string) => {
  const barCodeWithoutSpacesOrHyphens = barCode.replace(/[ -]/g, '');

  const is48Digits = /^\d{48}$/.test(barCodeWithoutSpacesOrHyphens);
  if (!is48Digits) {
    return 'Tipo de pagamento ainda não disponível';
  }

  const codeParts = [
    barCodeWithoutSpacesOrHyphens.substring(0, 12),
    barCodeWithoutSpacesOrHyphens.substring(12, 24),
    barCodeWithoutSpacesOrHyphens.substring(24, 36),
    barCodeWithoutSpacesOrHyphens.substring(36, 48),
  ];

  const areAllCodePartsValid = codeParts.every(part => {
    const isModuleInvalid = isModule10(barCodeWithoutSpacesOrHyphens)
      ? validateModule10(part)
      : validateModule11(part);

    return !isModuleInvalid;
  });

  return areAllCodePartsValid ? undefined : 'Código de barras inválido';
};



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/validator/validateBarcode/validateAgreementDigitableLine/index.ts